import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./../styles/styles.css"; 

function SignupStep1() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleNext = async () => { 
    if (!email) return;
    
    const API_URL = process.env.REACT_APP_API_URL;

    try {
      const response = await fetch(`${API_URL}/auth/check-email.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (data.available) {
        navigate('/signup/step2', { state: { email } });
      } else {
        setError("Cet email est invalide ou est déjà utilisé.");
      }
    } catch (err) {
      // console.error('Erreur API :', err);
      setError("Impossible de vérifier l'adresse email. Réessayez plus tard.");
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-card">
        <h2>Créez votre compte</h2>
        <p>Commencez par entrer votre adresse email :</p>
        <input
          type="email"
          placeholder="Adresse email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="signup-input"
        />
        {error && <p className="error-message">{error}</p>}
        <button onClick={handleNext} className="signup-button">
          Continuer
        </button>
      </div>
    </div>
  );
}

export default SignupStep1;
